const SchemaOptions=()=>{
return [{value:1,label:"Image"},{value:2,label:"Audio"},{value:3,label:"Video"}]
}
export default SchemaOptions;